import React, { Fragment, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { wire } from "react-hot-wire";

import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import IconButton from "@material-ui/core/IconButton";

import IconClose from "@material-ui/icons/Close";

import { DrawerService } from "services/drawer/Drawer.service";

import { Application } from "models/application/Application";

import DeploymentLogs from "./deployment-logs/DeploymentLogs.template";
import ImportLogs from "./import-logs/ImportLogs.template";
import ApplicationJobs from "./jobs/Jobs.template";

export function PreviewApplication({
  t,
  application,
  close,
  drawerService
}: {
  application: Application;
  close: () => void;
  drawerService: DrawerService;
} & WithTranslation) {
  const [applicationState, setApplicationState] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);

  const tabs = [
    {
      label: "Last deployment logs",
      component: (
        <DeploymentLogs
          application={application}
          setApplicationState={setApplicationState}
        />
      ),
      button: (
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          size="small"
          className="p-2"
          onClick={() =>
            drawerService.activate("deploy-application", {
              application,
              action: close
            })
          }
        >
          {t("application.deploy.deployButton")}
        </Button>
      )
    },
    {
      label: "Last import logs",
      component: (
        <ImportLogs
          application={application}
          setApplicationState={setApplicationState}
        />
      ),
      button: null
    },
    {
      label: "Jobs",
      component: (
        <ApplicationJobs
          application={application}
          setApplicationState={setApplicationState}
        />
      ),
      button: null
    }
  ];

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) =>
    setActiveTabIndex(newValue);

  return (
    <Fragment>
      <div className="d-flex justify-content-between modal-header py-2 px-3">
        <div className="d-flex align-items-center">
          <IconButton onClick={close} className="mr-3">
            <IconClose fontSize="small" />
          </IconButton>
          <h5 className="modal-title">
            {applicationState}
            {t(`application.preview.title.${activeTabIndex}`, {
              application
            })}
          </h5>
        </div>
        {tabs[activeTabIndex].button}
      </div>
      <div
        style={{
          backgroundColor: "rgb(241, 243, 244)",
          borderBottom: "1px solid rgb(222, 226, 230)"
        }}
      >
        <Tabs
          value={activeTabIndex}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="secondary"
        >
          {tabs.map(({ label, component, ...tab }, index) => (
            <Tab key={index} label={label} {...tab} />
          ))}
        </Tabs>
      </div>
      {tabs.map(
        (tab, index) =>
          activeTabIndex === index && (
            <Fragment key={index}>{tab.component}</Fragment>
          )
      )}
    </Fragment>
  );
}

export default wire(["drawerService"], withTranslation()(PreviewApplication));
